import { Component, Input, OnInit } from '@angular/core';
import { JobPositions, Orders, StatusButtons } from "../../../../_shared/interfaces";
import { AlertService, IAlertType, OrdersStoreService } from "../../../../_shared/services";
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from "@clr/angular";
import { CurrencyPipe, DatePipe, NgForOf, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { childArrowIcon, ClarityIcons, cogIcon } from "@cds/core/icon";
@Component({
  selector: 'app-job-details-orderlist',
  standalone: true,
  imports: [
    NgIf,
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    CurrencyPipe,
    ClrIconModule,
    NgForOf
  ],
  templateUrl: './job-details-orderlist.component.html',
  styleUrl: './job-details-orderlist.component.sass'
})
export class JobDetailsOrderlistComponent implements OnInit {
  orders: Orders[] = [];
  jobPositions: JobPositions[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusLabel = 'label-light-blue';
  statusText = '';

  @Input() projectID: string = '';
  @Input() jobID: number = 0;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'confirmed', display: 'Bestätigt', label: 'alert-info', icon: 'check-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'overdue', display: 'Überfällig', label: 'alert-danger', icon: 'exclamation-triangle'},
    { state: 'incomplete', display: 'Unvollständig', label: 'alert-danger', icon: 'exclamation-triangle'},
    { state: 'storno', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'shipped', display: 'Abgeschickt', label: 'alert-success', icon: 'check-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-green', icon: 'exclamation-circle'},
    { state: 'done', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor(
    private ordss: OrdersStoreService,
    private alertDispatcher: AlertService,
    ) {
    ClarityIcons.addIcons(childArrowIcon, cogIcon)
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadList();
    this.loadOrdersPositionsByJobId(this.projectID, this.jobID);
  }

  loadList() {
    this.ordss.getOrders(this.projectID,0, this.jobID, 'all').subscribe({
      next: data => {
        this.orders = data?.object ?? [];
        this.orders.forEach(order => {
          if (order.order_delivery === "0000-00-00" || order.order_delivery === "0002-11-30") {
            order.order_delivery = "---";
          }
        });
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

  loadOrdersPositionsByJobId(projectid: string, jobid: number) {
    this.ordss.getOrdersByJobId(projectid, jobid).subscribe({
      next: data3 => {
        this.jobPositions = data3?.object ?? [];
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(orderstatus: string, buttons: StatusButtons[]) {
    const idx = buttons.findIndex(el => el.state === orderstatus);
    return idx >= 0 ? idx : 0;
  };

  getCellStatus(status: string) {
    const statusline = this.findButtonStatus(status, this.statusButtons);
    return {
      'statusLabel': this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(orderstatus: string) {
    return "alert " + this.getCellStatus(orderstatus).statusLabel + " alert-sm";
  }
}
